<template>
    <ac-modal title="Confirm Email Success" ref="modalRef" :size-class="'modal-lg'">
        <template>
            <div class="row">
                <div class="col-xs-12" v-if="widgetReady">
                    <form>
                        <div class="row">
                            <div class="col-lg-12 info-board info-board-blue">
                                <p class="text-primary">
                                    Email has been put in queue for {{userData.fullName}} to {{userData.emailAddress}}. If the user is still not receiving the email you can copy the url below to send another way.
                                </p>
                            </div>
                        </div>
                         <div class="input-group">
                            <input type="text" class="form-control" ref="linkUrl" v-model="userData.url" readonly>
                            <span class="input-group-btn">
                                    <ac-button class="btn btn-sm btn-green margin-gutters" :action="copy">
                                        Copy URL
                                    </ac-button>
                            </span>
                        </div>
                    </form>
                    <div class="modal-footer">
                        <div class="button-box">
                            <ac-button class="btn btn-sm btn-red" :action="closeModal">Close</ac-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    export default {
        name: "ConfirmEmailModal",
        data() {
            return {
                userData: {},
                widgetReady: false
            };
        },
        methods: {
            async showModal(userData) {
                this.mapData('userData', userData);
                this.widgetReady = true;
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            copy() {
                this.$refs.linkUrl.select();
                document.execCommand('copy');
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
    .margin-gutters {
        margin-left: 20px !important;
        margin-bottom: 20px;
    }
</style>